import clsx from "clsx";

import { Chip } from "@/components/Chip/Chip";

type Props = {
  overallTime?: string | null;
};

function FlightArrow({ overallTime }: Props) {
  return (
    <div className="relative flex w-full items-center justify-center">
      <span className={clsx("relative z-10", { invisible: !overallTime })}>
        <Chip label={overallTime} size="small" color="primary" />
      </span>
      <div className="translate absolute h-[1.5px] w-full bg-surface-accent-stronger" />
    </div>
  );
}

export default FlightArrow;
